var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0782 10.6667V1.33333C13.0782 0.6 12.4701 0 11.7268 0H2.26737C1.52412 0 0.916016 0.6 0.916016 1.33333V10.6667C0.916016 11.4 1.52412 12 2.26737 12H11.7268C12.4701 12 13.0782 11.4 13.0782 10.6667ZM4.9025 7.32L6.32142 9.00667L8.41602 6.34667C8.55115 6.17333 8.82142 6.17333 8.95656 6.35333L11.3282 9.47333C11.4971 9.69333 11.3349 10.0067 11.0579 10.0067H2.95656C2.67277 10.0067 2.51737 9.68667 2.69304 9.46667L4.37547 7.33333C4.50385 7.16 4.76061 7.15333 4.9025 7.32Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageSelect);
export default __webpack_public_path__ + "static/media/image-select.2e703fe6d20cba567ffef3543125bf7c.svg";
export { ForwardRef as ReactComponent };